import React from 'react';
import { postUser, userApi } from '../APIs/userApi';
import { updateUserAttributes } from 'aws-amplify/auth';
import { changePassword } from '@aws-amplify/ui';
import { mutate } from 'swr';

export const postUserOne = (userId: string) => {
    const errorMessage = (msg) => {
        alert(msg || '未知のエラーが発生しました');
    };

    console.log('userId Post', userId);

    postUser(userId)
        .then((resp) => {
            if (resp.success) {
                console.log('resp.data', resp.data);
            } else {
            }
        })
        .catch((err) => {
            console.log(err);
            errorMessage(err.message);
        });

    return;
};

export interface UpdateUserSelfRequest {
    familyName: string;
    givenName: string;
    phoneNumber: string;
    oldPassword?: string;
    newPassword?: string;
}

export const postUserProfile = async ({
    familyName,
    givenName,
    phoneNumber,
    oldPassword,
    newPassword,
}: UpdateUserSelfRequest) => {
    const userAttributes = await updateUserAttributes({
        userAttributes: {
            family_name: familyName,
            given_name: givenName,
            phone_number: phoneNumber,
        },
    });
    mutate((key) => String(key).startsWith(userApi.get.userAttributesPrefix));
    return [
        userAttributes,
        oldPassword && newPassword
            ? await changePassword({
                  currentPassword: oldPassword,
                  newPassword,
              })
            : null,
    ];
};
